import { isEmpty } from 'lodash';
import React from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';

import MainNav from '../../../../components/Nav/MainNav';
import useCheckUserClubRole from '../../../../hooks/useCheckUserClubRole';
import { useHomeGamesWidget } from '../../../../model';
import type { NavLink } from '../../../../types/common';
import { ClubRoute, MemberRoute, UserClubRole } from '../../../../types/common';

import { TXTCLI_Blocked, TXTCLI_Members, TXTCLI_Pending } from './Tabs.messages.json';
import styles from './Tabs.scss';

const Tabs = () => {
  const { clubId } = useParams<{ clubId: string; section: string; subsection: string }>();
  const { widgetSelect } = useHomeGamesWidget();
  const isAdminOrManager = useCheckUserClubRole(clubId, [UserClubRole.Admin, UserClubRole.Manager]);
  const membersValues = { clubId, section: ClubRoute.Members };
  const { pending } = useSelector(widgetSelect.clubMembers);

  const links: NavLink[] = [
    {
      translation: TXTCLI_Members,
      alias: 'homeGamesClubs',
      values: { ...membersValues, subsection: MemberRoute.List }
    },
    {
      translation: TXTCLI_Pending,
      alias: 'homeGamesClubs',
      values: { ...membersValues, subsection: MemberRoute.Pending },
      notification: {
        visible: !isEmpty(pending),
        content: `+${pending.length}`,
        variant: 'standard'
      }
    },
    {
      translation: TXTCLI_Blocked,
      alias: 'homeGamesClubs',
      values: { ...membersValues, subsection: MemberRoute.Blocked }
    }
  ];

  if (isAdminOrManager) {
    return <MainNav links={links} innerClassName={styles.container} />;
  }

  return null;
};

export default Tabs;
